import { PageHeader } from '@core/components/PageHeader';
import { SearchBar } from '@core/components/SearchBar';
import React, { useContext } from 'react';
import { FaCreditCard } from 'react-icons/fa';
import { ContaContext } from '../../ContaContext';

const ContaSearchHeader = () => {
  const [, setSearch] = useContext(ContaContext).search;

  return (
    <PageHeader title="Contas" icon={<FaCreditCard />}>
      <div>
        <SearchBar onChange={setSearch} />
      </div>
    </PageHeader>
  );
};

export default ContaSearchHeader;
